import { render, staticRenderFns } from "./LevelFourTab.vue?vue&type=template&id=19dbd578"
import script from "./LevelFourTab.vue?vue&type=script&lang=js"
export * from "./LevelFourTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports